import { GameConstants } from "../../../GameConstants";
import { GameVars } from "../../../GameVars";
import { Translation } from "../../../Translation";

export class PotContainer extends Phaser.GameObjects.Container {

    private creditsLabel: Phaser.GameObjects.Text;
    private chipImage: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.y = 270;

        // temporalmente
        const credits = 0;

        this.creditsLabel = new Phaser.GameObjects.Text(this.scene, -15, 0, Translation.getText("POT") + ": " + GameVars.formatNumber(credits), { fontFamily: "Oswald-Medium", fontSize: "35px", color: "#25715D" });
        this.creditsLabel.setOrigin(.5);
        this.add(this.creditsLabel);

        this.chipImage = new Phaser.GameObjects.Image(this.scene, this.creditsLabel.width / 2 + 5, 0, "texture_atlas_1", "chip_pot_icon.png");
        this.add(this.chipImage);

        this.visible = false;
    }

    public updatePot(): void {

        if (!this.visible) {
            this.visible = true;
            this.alpha = 0;
            this.scene.tweens.add({
                targets: this,
                alpha: 1,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 250 / GameVars.gameSpeed,
                delay: 250
            });
        }

        this.creditsLabel.text = Translation.getText("POT") + ": " + GameVars.formatNumber(GameVars.gameState.pot);
        this.chipImage.x = this.creditsLabel.width / 2 + 5;
    }

    public hidePot(): void {

        this.visible = false;
    }
}
